module.exports = __webpack_public_path__ + "img/card_back.dad449aa.png";